import { pathToRegexp } from "path-to-regexp";

import type { PathParamDef } from "./define";

function extractTemplateParams(template: string): string[] {
  const { keys } = pathToRegexp(template);
  return keys.map(key => key.name);
}

function setDifference<T>(a: Set<T>, b: Set<T>): T[] {
  return [...a].filter(item => !b.has(item));
}

function formatParamList(params: string[]): string {
  return params.map(p => ":" + p).join(", ");
}

export function assertPathParamsMatchTemplate(
  template: string,
  declared: Record<string, PathParamDef> | undefined,
): void {
  const templateParams = new Set(extractTemplateParams(template));
  const declaredParams = new Set(Object.keys(declared ?? {}));

  const missing = setDifference(templateParams, declaredParams);
  const extra = setDifference(declaredParams, templateParams);

  if (missing.length === 0 && extra.length === 0) return;

  const issues = [
    missing.length > 0
      ? "missing declarations for " + formatParamList(missing)
      : null,
    extra.length > 0
      ? "declared params not in template: " + formatParamList(extra)
      : null,
  ]
    .filter(Boolean)
    .join("; ");

  throw new Error(
    `[lib/routes] pathParams mismatch for "${template}": ${issues}`,
  );
}
